import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.text.tertiary}`,
  padding: "32px 16px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  position: "relative",
}));

export const Title = styled(Typography)(({ theme }) => ({
  padding: "5px",
  position: "absolute",
  top: 0,
  left: "10px",
  backgroundColor: theme?.palette.background.paper,
  transform: "translate(0, -50%)",
  color: theme.palette.text.primary,
}));
